import { isChunkImportFailure as n } from "../helpers/chunkRecovery/chunkError.helper.js";
import { getRumShim as e } from "../helpers/datadog.helper.js";
import { Component as a } from "react";
var s = (r) => r.boundary ?? r.context?.boundary ?? "unknown", m = class extends a {
  state = { hasError: !1 };
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(r, t) {
    const o = e();
    o && (o.addError(r, {
      componentStack: t.componentStack ?? void 0,
      chunkLoadError: n(r),
      ...this.props.context,
      boundary: s(this.props)
    }), o.startSessionReplayRecording());
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
};
export {
  m as DatadogErrorBoundary
};

//# sourceMappingURL=DatadogErrorBoundary.js.map